// import React, { useState, useRef, useEffect } from "react";
// import "../../assets/Banking/RDDDPassbook.css";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
// import { Download, Printer } from "lucide-react";

// const RDDDPassbook = () => {
//   const [includeCompany, setIncludeCompany] = useState(true);
//   const [orientation, setOrientation] = useState("portrait");
//   const [company, setCompany] = useState(null);
//   const [branch, setBranch] = useState(null);
//   const [customer, setCustomer] = useState(null);
//   const [customerPhotoUrl, setCustomerPhotoUrl] = useState(null);

//   const { profile } = useSelector((state) => state.userProfile);
//   const dispatch = useDispatch();
//   const componentRef = useRef(null);

//   const { state } = useLocation();
//   const currentRowData = state?.row;

//   /* ------------------------- PDF Generate ------------------------- */
//   const generatePDF = async () => {
//     const input = componentRef.current;
//     const printSection = document.querySelector(
//       ".rddd-account-passbook-print-options"
//     );

//     if (printSection) printSection.style.display = "none";

//     const canvas = await html2canvas(input, {
//       scale: 3,
//       useCORS: true,
//       backgroundColor: "#ffffff",
//     });

//     if (printSection) printSection.style.display = "block";

//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: "a4",
//     });

//     const pageWidth = pdf.internal.pageSize.getWidth(); // 210
//     const pageHeight = pdf.internal.pageSize.getHeight(); // 297

//     // canvas px → mm
//     const pxToMm = (px) => px * 0.264583;
//     const imgWidth = pxToMm(canvas.width);
//     const imgHeight = pxToMm(canvas.height);

//     // scale ratio (important)
//     const scale = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);

//     const finalWidth = imgWidth * scale;
//     const finalHeight = imgHeight * scale;

//     // center align
//     const x = (pageWidth - finalWidth) / 2; // horizontal center
//     const y = 0; // top margin (mm) — 0 bhi rakh sakte ho

//     pdf.addImage(
//       imgData,
//       "PNG",
//       x,
//       y,
//       finalWidth,
//       finalHeight,
//       undefined,
//       "FAST"
//     );

//     pdf.save(`Passbook_${currentRowData?.customerName || "Customer"}.pdf`);
//   };

//   /* ------------------------- Direct Print ------------------------- */
//   const handleDirectPrint = async () => {
//     const input = componentRef.current;
//     const printSection = document.querySelector(
//       ".rddd-account-passbook-print-options"
//     );
//     if (printSection) printSection.style.display = "none";

//     const canvas = await html2canvas(input, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#fff",
//     });

//     if (printSection) printSection.style.display = "block";

//     const imgData = canvas.toDataURL("image/png");
//     const isLandscape = orientation === "landscape";

//     const printWindow = window.open("", "_blank");
//     printWindow.document.write(`
//     <html>
//       <head>
//         <title>Print Passbook</title>
//         <style>
//              @page {
//         size: ${isLandscape ? "150mm 105mm" : "105mm 150mm"};
//         margin: 0;
//       }
//       body {
//         margin: 0;
//         padding: 0;
//       }
//       .passbook-img {
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: auto;
//       }
//         </style>
//       </head>
//       <body>
//         <img class="passbook-img" src="${imgData}" />
//       </body>
//     </html>
//   `);

//     printWindow.document.close();
//     printWindow.onload = () => {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     };
//   };

//   /* ------------------------- Fetch Profile & Customer ------------------------- */
//   useEffect(() => {
//     const loadAll = async () => {
//       try {
//         const profileData =
//           profile || (await dispatch(fetchUserProfile())).payload;
//         if (!profileData) return;

//         if (profileData.superAdminId) {
//           const res = await fetch(
//             `https://payyug.in/api/get-company?superAdminId=${profileData.superAdminId}`
//           );
//           const data = await res.json();
//           if (res.ok) {
//             if (data.logo)
//               data.logoUrl = `https://payyug.in/${data.logo.replace(
//                 /^images\//,
//                 ""
//               )}`;
//             setCompany(data);
//           }
//         }

//         if (currentRowData?.customerId) {
//           const res = await fetch(
//             `https://payyug.in/api/customers-get-userId?userId=${currentRowData.customerId}&branchId=${profileData.id}`
//           );
//           const data = await res.json();
//           setCustomer(data.data);
//         }

//         if (currentRowData?.customerId && profileData?.superAdminId) {
//           const res = await fetch(
//             `https://payyug.in/api/list-kyc?userId=${currentRowData.customerId}&superAdminId=${profileData.superAdminId}&createdById=${currentRowData.createdById}`
//           );
//           const data = await res.json();
//           const photoDoc = data.documents?.find(
//             (doc) => doc.docName?.toLowerCase() === "photo"
//           );
//           if (photoDoc?.docImage)
//             setCustomerPhotoUrl(
//               `https://payyug.in/uploads/${photoDoc.docImage}`
//             );
//         }

//         if (profileData.branchId) {
//           const res = await fetch(
//             `https://payyug.in/api/get-byId/${profileData.branchId}`
//           );
//           const branchData = await res.json();
//           setBranch(branchData.data || branchData);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     loadAll();
//   }, []);

//   return (
//     <div className="rddd-account-passbook-page">
//       <div ref={componentRef}>
//         <div
//           className={`rddd-account-passbook ${
//             orientation === "landscape" ? "horizontal" : "vertical"
//           }`}
//         >
//           {/* Header */}
//           {includeCompany && company && (
//             <div className="rddd-account-passbook-company-header">
//               {company.logoUrl && (
//                 <img
//                   src={company.logoUrl}
//                   alt="Logo"
//                   className="rddd-account-passbook-company-logo-img"
//                 />
//               )}
//               <div className="rddd-account-passbook-heading-paragraphs">
//                 <h2>{company.name}</h2>
//                 <p>
//                   <span>CIN:</span> {company.cin}
//                 </p>
//                 <p>
//                   <span>Email:</span> {company.email}
//                 </p>
//                 <p>
//                   <span>Phone:</span> {company.contact}
//                 </p>
//               </div>
//             </div>
//           )}

//           {/* Customer & Account Details */}
//           <div className="rddd-account-passbook-details-card">
//             <div className="rddd-account-passbook-customer-section">
//               <h4>Customer Details</h4>
//               <div
//                 className={`rddd-account-passbook-customer-details ${
//                   orientation === "landscape" ? "horizontal" : "vertical"
//                 }`}
//               >
//                 <img
//                   src={
//                     customerPhotoUrl ||
//                     "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
//                   }
//                   alt="Customer"
//                   className="rddd-account-passbook-customer-photo"
//                 />
//                 <div
//                   className={`rddd-account-passbook-customer-info ${
//                     orientation === "landscape" ? "horizontal" : "vertical"
//                   }`}
//                 >
//                   <div>
//                     <p>
//                       <span>Name :</span>{" "}
//                       {currentRowData?.customerName || "N/A"}
//                     </p>
//                     <p>
//                       <span>Guardian :</span> {customer?.guardianName || "N/A"}
//                     </p>
//                     <p>
//                       <span>Aadhar :</span> {customer?.aadhaarNumber || "N/A"}
//                     </p>
//                     <p>
//                       <span>PAN :</span> {customer?.panNumber || "N/A"}
//                     </p>
//                   </div>
//                   <div>
//                     <p>
//                       <span>Cus ID :</span> {currentRowData?.customerId}
//                     </p>
//                     <p>
//                       <span>Phone :</span> {customer?.mobileNumber || "N/A"}
//                     </p>
//                     <p>
//                       <span>Address :</span> {customer?.address || "N/A"}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <h4 className="rddd-account-passbook-branch-h4">Branch Details</h4>
//             <div className="rddd-account-passbook-branch-info">
//               <p>
//                 <span>Name :</span> {branch?.name || "N/A"}
//               </p>
//               <p>
//                 <span>Code :</span> {branch?.code || "N/A"}
//               </p>
//               <p>
//                 <span>Address :</span> {branch?.address || "N/A"}
//               </p>
//             </div>

//             {/* Account Details */}
//             <h4 className="rddd-account-passbook-accouont-h4">Account Details</h4>
//             <div
//               className={`rddd-account-passbook-accouont-details-section-flex ${orientation}`}
//             >
//               <div className="rddd-account-passbook-accouont-details-info">
//                 <p>
//                   <span>Account No :</span> {currentRowData?.accountNo || "N/A"}
//                 </p>
//                 <p>
//                   <span>Account Type :</span>{" "}
//                   {currentRowData?.accountType + " Account" || "N/A"}
//                 </p>
//                 <p>
//                   <span>Account Scheme :</span>{" "}
//                   {currentRowData?.schemeName || "N/A"}
//                 </p>
//               </div>
//               <div className="rddd-account-passbook-accouont-details-info">
//                 <p>
//                   <span>Total Interest :</span>{" "}
//                   {currentRowData?.totalInterest || "N/A"}
//                 </p>
//                 <p>
//                   <span>Maturity Amount :</span>{" "}
//                   {currentRowData?.maturityAmount || "N/A"}
//                 </p>
//                 <p>
//                   <span>Maturity Date :</span>{" "}
//                   {currentRowData?.maturityDate
//                     ? new Date(currentRowData.maturityDate).toLocaleDateString(
//                         "en-IN"
//                       )
//                     : "N/A"}
//                 </p>
//               </div>
//               <div className="rddd-account-passbook-accouont-details-branch-info">
//                 <p>
//                   <span>Opening Date :</span>{" "}
//                   {currentRowData?.openingDate
//                     ? new Date(currentRowData.openingDate).toLocaleDateString(
//                         "en-GB"
//                       )
//                     : "N/A"}
//                 </p>
//                 <p>
//                   <span>Branch :</span> {branch?.name}
//                 </p>
//                 <p>
//                   <span>Branch Code :</span> {branch?.code}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Options */}
//       <div className="rddd-account-passbook-print-options">
//         <h3>🖨️ Print & PDF Options</h3>

//         <div className="rddd-account-passbook-print-option-row">
//           <p>Include Company Details :</p>
//           <label>
//             <input
//               type="radio"
//               name="company"
//               checked={includeCompany}
//               onChange={() => setIncludeCompany(true)}
//             />{" "}
//             Yes
//           </label>
//           <label>
//             <input
//               type="radio"
//               name="company"
//               checked={!includeCompany}
//               onChange={() => setIncludeCompany(false)}
//             />{" "}
//             No
//           </label>
//         </div>

//         <div className="rddd-account-passbook-print-option-row">
//           <p>Page Orientation :</p>
//           <label>
//             <input
//               type="radio"
//               name="orientation"
//               checked={orientation === "portrait"}
//               onChange={() => setOrientation("portrait")}
//             />{" "}
//             Vertical
//           </label>
//           <label>
//             <input
//               type="radio"
//               name="orientation"
//               checked={orientation === "landscape"}
//               onChange={() => setOrientation("landscape")}
//             />{" "}
//             Horizontal
//           </label>
//         </div>

//         <button className="rddd-account-passbook-print-btn" onClick={generatePDF}>
//           <Download size={15} /> Download PDF
//         </button>
//         <button
//           style={{ marginLeft: "10px" }}
//           className="rddd-account-passbook-print-btn"
//           onClick={handleDirectPrint}
//         >
//           <Printer size={15} /> Print Passbook
//         </button>
//       </div>
//     </div>
//   );
// };

// export default RDDDPassbook;




import React, { useState, useRef, useEffect } from "react";
import "../../assets/Banking/RDDDPassbook.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { Download, Printer, RotateCw } from "lucide-react";

const RDDDPassbook = () => {
  const [includeCompany, setIncludeCompany] = useState(true);
  const [orientation, setOrientation] = useState("portrait");

  const [customWidth, setCustomWidth] = useState(140);
  const [customHeight, setCustomHeight] = useState(210);

  const [rotatePrint, setRotatePrint] = useState(false);

  const [company, setCompany] = useState(null);
  const [branch, setBranch] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [customerPhotoUrl, setCustomerPhotoUrl] = useState(null);

  const [topSpace, setTopSpace] = useState(10);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const componentRef = useRef(null);

  const { state } = useLocation();
  const currentRowData = state?.row;

  const handleOrientationChange = (mode) => {
    setOrientation(mode);
    if (mode === "portrait") {
      setCustomWidth(140);
      setCustomHeight(210);
    } else {
      setCustomWidth(240);
      setCustomHeight(160);
    }
  };

  /* ------------------------- PDF Generate ------------------------- */
  const generatePDF = async () => {
    const input = componentRef.current;
    const printSection = document.querySelector(
      ".rddd-account-passbook-print-options",
    );

    if (printSection) printSection.style.display = "none";

    const canvas = await html2canvas(input, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    if (printSection) printSection.style.display = "block";

    let imgData = canvas.toDataURL("image/png");

    // PDF configuration using custom dimensions
    const pdf = new jsPDF({
      orientation: orientation,
      unit: "mm",
      format: [customWidth, customHeight],
    });

    // If rotation is enabled for PDF as well
    if (rotatePrint) {
      const rotatedCanvas = document.createElement("canvas");
      rotatedCanvas.width = canvas.height;
      rotatedCanvas.height = canvas.width;
      const ctx = rotatedCanvas.getContext("2d");
      ctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
      ctx.rotate((90 * Math.PI) / 180);
      ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);
      imgData = rotatedCanvas.toDataURL("image/png");
    }

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      customWidth,
      customHeight,
      undefined,
      "FAST",
    );
    pdf.save(`${currentRowData?.customerName || "Customer"}_${currentRowData?.accountType}_Passbook.pdf`);
  };

  /* ------------------------- Direct Print ------------------------- */
  const handleDirectPrint = async () => {
    const input = componentRef.current;
    const printSection = document.querySelector(
      ".rddd-account-passbook-print-options",
    );
    if (printSection) printSection.style.display = "none";
    input.classList.add("print-clean");

    const canvas = await html2canvas(input, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#fff",
    });

    input.classList.remove("print-clean");

    if (printSection) printSection.style.display = "block";

    let imgData = canvas.toDataURL("image/png");

    if (rotatePrint) {
      const rotatedCanvas = document.createElement("canvas");

      rotatedCanvas.width = canvas.height;
      rotatedCanvas.height = canvas.width;

      const ctx = rotatedCanvas.getContext("2d");

      ctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);

      ctx.rotate(Math.PI / 2);

      ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);

      imgData = rotatedCanvas.toDataURL("image/png");
    }

    const pageWidth = rotatePrint ? customHeight : customWidth;

    const pageHeight = rotatePrint ? customWidth : customHeight;

    const printWindow = window.open("", "_blank");
    printWindow?.document?.write(`
    <html>
      <head>
        <title>Print Passbook</title>
        <style>
          @page { 
            size: ${pageWidth}mm ${pageHeight}mm;
  margin: 0mm; 
          }
          body { 
            margin: 0; 
            padding: 0; 
            display: flex; 
            justify-content: center; 
            align-items: center; 
            background: #fff;
          }
          .passbook-img { 
width: ${pageWidth}mm;
  height: ${pageHeight}mm;
  object-fit: fill;
  display: block;
          }
        </style>
      </head>
      <body>
        <img class="passbook-img" src="${imgData}" />
      </body>
    </html>
  `);

    printWindow?.document?.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  /* ------------------------- Fetch Profile & Customer ------------------------- */
  useEffect(() => {
    const loadAll = async () => {
      try {
        const profileData =
          profile || (await dispatch(fetchUserProfile())).payload;
        if (!profileData) return;

        if (profileData.superAdminId) {
          const res = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profileData.superAdminId}`,
          );
          const data = await res.json();
          if (res.ok) {
            if (data.logo)
              data.logoUrl = `https://payyug.in/${data.logo.replace(
                /^images\//,
                "",
              )}`;
            setCompany(data);
          }
        }

        if (currentRowData?.customerId) {
          const res = await fetch(
            `https://payyug.in/api/customers-get-userId?userId=${currentRowData.customerId}&branchId=${profileData.id}`,
          );
          const data = await res.json();
          setCustomer(data.data);
        }

        if (currentRowData?.customerId && profileData?.superAdminId) {
          const res = await fetch(
            `https://payyug.in/api/list-kyc?userId=${currentRowData.customerId}&superAdminId=${profileData.superAdminId}&createdById=${currentRowData.createdById}`,
          );
          const data = await res.json();
          const photoDoc = data.documents?.find(
            (doc) => doc.docName?.toLowerCase() === "photo",
          );
          if (photoDoc?.docImage)
            setCustomerPhotoUrl(
              `https://payyug.in/uploads/${photoDoc.docImage}`,
            );
        }

        if (profileData.branchId) {
          const res = await fetch(
            `https://payyug.in/api/get-byId/${profileData.branchId}`,
          );
          const branchData = await res.json();
          setBranch(branchData.data || branchData);
        }
      } catch (err) {
        console.error(err);
      }
    };
    loadAll();
  }, [dispatch, profile, currentRowData]);

  const BASE_WIDTH =
  orientation === "landscape"
    ? 240
    : 140;

const BASE_HEIGHT =
  orientation === "landscape"
    ? 160
    : 210;

const scale = Math.max(
  0.6,
  Math.min(
    customWidth / BASE_WIDTH,
    customHeight / BASE_HEIGHT
  )
);

  const isLandscape = customWidth > customHeight;

  return (
    <div className="rddd-account-passbook-page">
      <div className="passbook-capture-wrapper">
        <div
          ref={componentRef}
          className={`rddd-account-passbook ${orientation === "landscape" ? "horizontal" : "vertical"}`}
          style={{
  width: `${customWidth}mm`,
  height: `${customHeight}mm`,
  paddingTop: `${topSpace}mm`,
  boxSizing: "border-box",
  "--scale": scale,
}}
        >
          {/* Header */}
          {includeCompany && company && (
            <div className="rddd-account-passbook-company-header">
              {company.logoUrl && (
                <img
                  src={company.logoUrl}
                  alt="Logo"
                  className="rddd-account-passbook-company-logo-img"
                />
              )}
              <div className="rddd-account-passbook-heading-paragraphs">
                <h2>{company.name}</h2>
                <p>
                  <span>CIN:</span> {company.cin}
                </p>
                <p>
                  <span>Email:</span> {company.email}
                </p>
                <p>
                  <span>Phone:</span> {company.contact}
                </p>
              </div>
            </div>
          )}

          {/* Customer & Account Details */}
          <div className="rddd-account-passbook-details-card">
            <div className="rddd-account-passbook-customer-section">
              <h4>Customer Details</h4>
              <div
                className={`rddd-account-passbook-customer-details ${
                  orientation === "landscape" ? "horizontal" : "vertical"
                }`}
              >
                <img
                  src={
                    customerPhotoUrl ||
                    "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
                  }
                  alt="Customer"
                  className="rddd-account-passbook-customer-photo"
                />
                <div
                  className={`rddd-account-passbook-customer-info ${
                    orientation === "landscape" ? "horizontal" : "vertical"
                  }`}
                >
                  <div>
                    <p>
                      <span>Name :</span>{" "}
                      {currentRowData?.customerName || "N/A"}
                    </p>
                    <p>
                      <span>Guardian :</span> {customer?.guardianName || "N/A"}
                    </p>
                    <p>
                      <span>Aadhar :</span> {customer?.aadhaarNumber || "N/A"}
                    </p>
                    <p>
                      <span>PAN :</span> {customer?.panNumber || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span>Cus ID :</span> {currentRowData?.customerId}
                    </p>
                    <p>
                      <span>Phone :</span> {customer?.mobileNumber || "N/A"}
                    </p>
                    <p>
                      <span>Address :</span> {customer?.address || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <h4 className="rddd-account-passbook-branch-h4">Branch Details</h4>
            <div className="rddd-account-passbook-branch-info">
              <p>
                <span>Name :</span> {branch?.name || "N/A"}
              </p>
              <p>
                <span>Code :</span> {branch?.code || "N/A"}
              </p>
              <p>
                <span>Address :</span> {branch?.address || "N/A"}
              </p>
            </div>

            {/* Account Details */}
            <h4 className="rddd-account-passbook-accouont-h4">
              Account Details
            </h4>
            <div
              className={`rddd-account-passbook-accouont-details-section-flex ${
                orientation === "landscape" ? "landscape" : "portrait"
              }`}
            >
              <div className="rddd-account-passbook-accouont-details-info">
                <p>
                  <span>Account No :</span> {currentRowData?.accountNo || "N/A"}
                </p>
                <p>
                  <span>Account Type :</span>{" "}
                  {currentRowData?.accountType + " Account" || "N/A"}
                </p>
                <p>
                  <span>Account Scheme :</span>{" "}
                  {currentRowData?.schemeName || "N/A"}
                </p>
              </div>
              <div className="rddd-account-passbook-accouont-details-info">
                <p>
                  <span>Total Interest :</span>{" "}
                  {currentRowData?.totalInterest || "N/A"}
                </p>
                <p>
                  <span>Maturity Amount :</span>{" "}
                  {currentRowData?.maturityAmount || "N/A"}
                </p>
                <p>
                  <span>Maturity Date :</span>{" "}
                  {currentRowData?.maturityDate
                    ? new Date(currentRowData.maturityDate).toLocaleDateString(
                        "en-IN",
                      )
                    : "N/A"}
                </p>
              </div>
              <div className="rddd-rddd-account-passbook-accouont-details-branch-info">
                <p>
                  <span>Opening Date :</span>{" "}
                  {currentRowData?.openingDate
                    ? new Date(currentRowData.openingDate).toLocaleDateString(
                        "en-GB",
                      )
                    : "N/A"}
                </p>
                <p>
                  <span>Branch :</span> {branch?.name}
                </p>
                <p>
                  <span>Branch Code :</span> {branch?.code}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Options */}
      <div className="rddd-account-passbook-print-options">
        <h3>🖨️ Print & PDF Options</h3>

        <div className="rddd-account-passbook-print-option-row">
          <p>Include Company Details :</p>
          <label>
            <input
              type="radio"
              name="company"
              checked={includeCompany}
              onChange={() => setIncludeCompany(true)}
            />{" "}
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="company"
              checked={!includeCompany}
              onChange={() => setIncludeCompany(false)}
            />{" "}
            No
          </label>
        </div>

        <div className="rddd-account-passbook-print-option-row">
          <p>Page Orientation :</p>
          <label>
            <input
              type="radio"
              name="orientation"
              checked={orientation === "portrait"}
              onChange={() => handleOrientationChange("portrait")}
            />{" "}
            Vertical
          </label>
          <label>
            <input
              type="radio"
              name="orientation"
              checked={orientation === "landscape"}
              onChange={() => handleOrientationChange("landscape")}
            />{" "}
            Horizontal
          </label>
        </div>

        {/* --- CUSTOM SIZE CONTROLS --- */}
        <div className="rddd-account-passbook-custom-sizes-box">
          <h4>Custom Dimensions (mm)</h4>
          <div className="rddd-account-passbook-print-option-row">
            <label>
              Width (mm):
              <input
                type="number"
                value={customWidth}
                onChange={(e) => setCustomWidth(Number(e.target.value))}
                className="size-input"
              />
            </label>
            <label style={{ marginLeft: "20px" }}>
              Height (mm):
              <input
                type="number"
                value={customHeight}
                onChange={(e) => setCustomHeight(Number(e.target.value))}
                className="size-input"
              />
            </label>
          </div>
        </div>

        <div className="rddd-account-passbook-custom-sizes-box">
          <h4>Spacing Controls</h4>

          <div className="rddd-account-passbook-print-option-row">
            <label>
              Top Space (mm):
              <input
                type="number"
                value={topSpace}
                min="0"
                onChange={(e) => setTopSpace(Number(e.target.value))}
                className="size-input"
              />
            </label>
          </div>
        </div>

        {/* --- ROTATION TOGGLE --- */}
        <div className="rddd-account-passbook-print-option-row rotation-row">
          <p>Print Page Rotation:</p>
          {isLandscape && (
            <button
              type="button"
              className={`rotate-toggle-btn ${rotatePrint ? "active" : ""}`}
              onClick={() => setRotatePrint(!rotatePrint)}
            >
              <RotateCw size={14} />
              {rotatePrint ? "Portrait Feed ON" : "Portrait Feed OFF"}
            </button>
          )}
        </div>

        <div className="action-buttons-container" style={{ marginTop: "15px" }}>
          <button
            className="rddd-account-passbook-print-btn"
            onClick={generatePDF}
          >
            <Download size={15} /> Download PDF
          </button>
          <button
            style={{ marginLeft: "10px" }}
            className="rddd-account-passbook-print-btn print-blue"
            onClick={handleDirectPrint}
          >
            <Printer size={15} /> Print Passbook
          </button>
        </div>
      </div>
    </div>
  );
};

export default RDDDPassbook;
